import httpClient from "@/services/httpClient";
import { server } from "@/services/constants";

export const createPDPA = (body) => {
    return httpClient.post(server.PDPA_URL + '/create', body);
};

export const checkIfUserAgreed = (id) => {
    return httpClient.get(server.PDPA_URL + `/account-id/${id}`);
};